export const Money = function() {
    this.groupSeparatorRegex = /\s/gi;
    this.groupSeparator = ' ';
    this.radixPointRegex = /\,/gi;
    this.radixPoint = ',';
};

Money.prototype.toFloat = function(value) {
    return parseFloat(this.normalize(value));
};

Money.prototype.normalize = function(value) {
    if(value === '0' || value === '') return '0';
    if(typeof value === 'string') {
        return value.replace(this.groupSeparatorRegex, '').replace(this.radixPointRegex,'.');
    } else {
        return value;
    }
};

// locale 'fr' matches client requirements for default parsing of money value
Money.prototype.localize = function(value, minDigits = 2, maxDigits = minDigits, locale = 'fr') {
    return parseFloat(this.normalize(value)).toLocaleString(locale, {
        minimumFractionDigits: minDigits,
        maximumFractionDigits: maxDigits,
        useGrouping: true,
        style: 'decimal',
        minimumIntegerDigits: 1
    })
};

Money.prototype.localizeWithInt = function(value, minDigits = 2, maxDigits = minDigits, locale = 'fr') {
    return parseFloat(this.normalize(value)).toLocaleString(locale, {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
        useGrouping: true,
        style: 'decimal',
        minimumIntegerDigits: 1
    })
};

Money.prototype.format = function (string, digits =2) {
    return this.localize(this.normalize(string), digits);
};
Money.prototype.formatInt = function (string, digits =0) {
    return this.localize(this.normalize(string), digits);
};
Money.prototype.convertToLocale = function(value, digits = 2, locale = 'pl') {
  return this.localize(this.normalize(value), digits, digits, locale);
};
